const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
const KEY = `04f6f57f-38b1-4f9a-ab94-dec4a0ab0959`;
const TIMEOUT_SEC = 10;
const REC_PER_PAGE = 10;
const MODAL_CLOSE_SEC = 2.5;

export { API_URL, KEY, TIMEOUT_SEC, REC_PER_PAGE, MODAL_CLOSE_SEC };
